import { useLocation } from "react-router-dom";

export const useQuizBasePath = () => {
  const location = useLocation();
  return location.pathname.startsWith("/management/")
    ? "/management/quiz"
    : "/operation/quiz";
};
